export const en = {
    'add-placements': {
        one: 'To expand reach, add surfaces in the format {formats}',
        some: 'To expand reach, add surfaces with these formats: {formats}',
        many: 'To expand reach, add surfaces with these formats: {formats}',
        none: ''
    },
    'ratio-info': {
        one: '{format} for {count} creative',
        some: '{format} for {count} creatives',
        many: '{format} for {count} creatives',
        none: '{format} for {count} creatives'
    },
    title: 'Add billboards in suitable formats',
    'title-hint': 'This recommendation appears as there are no billboards suitable for the creatives selected',
    'video-format': '{width}x{height} → {duration} sec.'
};
